import { FC, useContext } from 'react';
import styled from 'styled-components';
import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import { IntroModulesContext } from './IntroModulesContext';
import IntroModuleMedia from './IntroModuleMedia';
import IntroModuleText from './IntroModuleText';
import IntroModulesBackButton from './IntroModulesBackButton';

const Container = styled(Stack)`
  min-height: 400px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  position: relative;
`;

const IntroModulesViewBody: FC = () => {
  const {
    isLoading,
    goToNextModule,
    isOnLastModule,
    completeIntroModules,
    error,
  } = useContext(IntroModulesContext);

  if (error) {
    return (
      <Alert
        severity="error"
        action={
          <Button
            onClick={completeIntroModules}
            variant="contained"
            sx={{ margin: 'auto 0' }}
          >
            Continue
          </Button>
        }
      >
        <AlertTitle>Could not fetch onboarding info</AlertTitle>
        Don&apos;t worry. You will be able to see the onboarding info as posts
        on the home page.
      </Alert>
    );
  }
  return (
    <Container>
      <IntroModulesBackButton />
      <IntroModuleMedia />
      <Stack p={4} height="100%" gap={4}>
        <IntroModuleText />
        <Button
          onClick={isOnLastModule ? completeIntroModules : goToNextModule}
          variant="contained"
          size="large"
          disabled={isLoading}
        >
          {isOnLastModule ? 'Finish' : 'Next'}
        </Button>
      </Stack>
    </Container>
  );
};

export default IntroModulesViewBody;
